import { GoMotoComponent } from '../../../API/GoMoto.types';
import { CaseProps } from './JSXCase.types';

/**
 * This control acts like a case inside of a switch statement, except
 * it works for ReactNodes or JSX.Elements that are rendered.
 *
 * @param props - This object contains multiple values, but we only require the children for this control
 */
const JSXCase: GoMotoComponent<CaseProps> = (props) => {
    return (
        <>
            {props.children}
        </>
    );
};

export default JSXCase;